<script>
import FluentIcon from '../../../../../shared/components/FluentIcon/Index.vue';

export default {
  components: { FluentIcon },
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    characterCount: { type: Number, default: null },
    maxLength: { type: Number, default: null },
  },
};
</script>

<template>
  <div class="space-y-1 max-w-full">
    <label
      v-if="label"
      :for="name"
      class="flex items-end text-sm font-bold leading-6 text-[#1A1A1C] dark:text-white max-w-full mb-2"
      :class="{ 'text-red-500': hasError }"
    >
      <slot name="label">
        {{ label }}
      </slot>
      <slot name="rightOfLabel" class="mr-3">
        <FluentIcon
          v-if="required"
          size="8"
          icon="star"
          class="text-red-500 mb-3"
        />
      </slot>
    </label>
    <div class="w-full max-w-full !mt-0">
      <div class="flex items-center relative w-full max-w-full">
        <FluentIcon
          v-if="icon"
          size="16"
          :icon="icon"
          class="absolute left-2 transform text-slate-400 dark:text-slate-600 w-5 h-5"
        />
        <slot />
      </div>

      <div
        v-if="(errorMessage && hasError) || (maxLength != null && characterCount != null)"
        class="flex items-center justify-between gap-2 mt-2 min-h-[1.25rem]"
      >
        <div
          v-if="errorMessage && hasError"
          class="inline-flex items-center min-w-0 flex-1"
        >
          <FluentIcon
            size="16"
            icon="warning"
            class="text-red-500 mr-2 shrink-0"
          />
          <span class="text-xs text-red-400 leading-2 break-words">
            {{ errorMessage }}
          </span>
        </div>
        <span
          v-if="maxLength != null && characterCount != null"
          class="flex-shrink-0 text-xs tabular-nums text-n-slate-10 dark:text-slate-400"
        >
          {{ characterCount }} / {{ maxLength }}
        </span>
      </div>
    </div>
  </div>
</template>
